<script setup lang="ts">
  import IconBase from './IconBase.vue'
  withDefaults(
    defineProps<{
      color?: string
      height?: number | string
      viewBoxValue?: string
      width?: number | string
    }>(),
    {
      width: 15,
      height: 15,
      color: 'currentColor',
      viewBoxValue: `0 0 15 15`,
    },
  )
</script>

<template>
  <IconBase
    :width="width"
    :height="height"
    :color="color"
    :view-box-value="viewBoxValue"
  >
    <path
      d="M10.0625 5.6875C10.0625 3.28125 8.09375 1.3125 5.6875 1.3125C3.28125 1.3125 1.3125 3.28125 1.3125 5.6875C1.3125 8.09375 3.28125 10.0625 5.6875 10.0625C8.09375 10.0625 10.0625 8.09375 10.0625 5.6875ZM9.21484 10.1445C8.25781 10.9102 7.02734 11.375 5.6875 11.375C2.54297 11.375 0 8.83203 0 5.6875C0 2.54297 2.54297 0 5.6875 0C8.83203 0 11.375 2.54297 11.375 5.6875C11.375 7.02734 10.9102 8.25781 10.1445 9.21484L13.8086 12.8789C14.0547 13.125 14.0547 13.5625 13.8086 13.8086C13.5625 14.0547 13.125 14.0547 12.8789 13.8086L9.21484 10.1445Z"
      fill="currentColor"
    />
  </IconBase>
</template>

<style scoped lang="scss"></style>
